import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ILinkifyOptions } from './linkify.interface';

const linkifyStr = require('linkifyjs/string');

@Pipe({
  name: 'linkify',
})
export class LinkifyPipe implements PipeTransform {
  constructor(private _domSanitizer: DomSanitizer) {}

  transform(value: any, linkifyOptions?: ILinkifyOptions): SafeHtml {
    return value
      ? this._domSanitizer.bypassSecurityTrustHtml(
          linkifyStr(value, {
            className: (linkifyOptions.classNames || []).join(' '),
            target: {
              url: linkifyOptions.target || null,
            },
          })
        )
      : '';
  }
}
